import * as BootstrapModal from "@/shared/ui/bootstrapModal";

/**
 * Runs the export right away if the table has rows, otherwise asks first whether a report without content should be
 * generated.
 */
export function confirmExportOfEmptyTable(rowCount: number, exportAction: () => void) {
	if (rowCount > 0) {
		exportAction();
		return;
	}
	new BootstrapModal.Modal({
		title: "reports.export.confirm.title",
		message: messages["reports.export.confirm.message"],
		css: {
			header: "bg-primary"
		},
		buttons: [{
			text: "reports.export.button.continue",
			action: (m) => {
				exportAction();
				m.close();
			},
			css: "btn-primary"
		}, {
			text: "confirmation.cancel",
			css: "btn-default",
			action: (m) => {
				m.close();
			}
		}]
	}).show();
}
